import React from 'react';
import { Stack, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

import { BasicActionDialog } from 'features/ui/base-dialogs';
import { ManualTag } from '../contact-management.types';

interface Props {
  open: boolean;
  loading: boolean;
  tag: ManualTag | null;

  handleClose(): void;
  handleDeleteTag(): void;
}

const DeleteTagDialog: React.FC<Props> = ({
  open,
  loading,
  tag,
  handleClose,
  handleDeleteTag
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <BasicActionDialog
      open={open}
      variant="warning" // ensures your custom styling for 'warning' is applied
      loading={loading}
      dialogTitle={t('deleteTag')}
      maxWidth="xs"
      proceedButtonText={t('ok')}
      handleProceed={handleDeleteTag}
      cancelButtonText={t('cancel')}
      handleClose={handleClose}
    // If your <BasicActionDialog> supports style overrides, you can pass them like:
    // dialogPaperStyle={classes.dialogPaper}
    // dialogActionsStyle={classes.dialogActions}
    >
      <Stack spacing={2} className={classes.dialogContent}>
        <Typography className={classes.text}>
          <Trans i18nKey="deleteTagContent1" values={{ tagName: tag?.name || '' }}>
            Are you sure you want to delete <strong>{tag?.name || ''}</strong>?
          </Trans>
        </Typography>
        <Typography className={classes.text}>{t('deleteTagContent2')}</Typography>
      </Stack>
    </BasicActionDialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  dialogContent: {
    // Add custom spacing or styling if needed, e.g.:
    // marginTop: theme.spacing(1),
  },
  text: {
    fontSize: theme.typography.pxToRem(13),
    // You could also adjust lineHeight, color, etc. to match ContactOverview exactly:
    // color: theme.palette.text.primary,
  },
  // If <BasicActionDialog> allows custom classes for the dialog paper or actions, you can add:
  // dialogPaper: {
  //   borderRadius: '12px',
  //   backgroundColor: '#FFF',
  // },
  // dialogActions: {
  //   padding: theme.spacing(2),
  //   display: 'flex',
  //   justifyContent: 'flex-end',
  //   gap: theme.spacing(2),
  // },
}));

export default DeleteTagDialog;
